import React, {Component} from "react";
import {connect} from "react-redux";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import Button from "../../components/Button";
import {fromJS, List, Map} from "immutable";
import {graphql} from "react-apollo";
import {GET_ORDER_WITH_PRODUCTS, ON_ORDER_UPDATED} from "../../queries/sales";
import Address from "../../shipping/controls/Address";
import TrackingList from "../../shipping/views/TrackingList";
import ProductTable from "../../customers/shared/ProductTable";
import InvoiceStorage from "../../lib/InvoiceStorage";
import WarningBanner from "../../components/WarningBanner";
import ChargeView from "./ChargeView";
import {
  requestRecordPayment, 
  requestCheckPaymentStatus, 
  requestRetryPayment, 
  requestViewChargePayments,
} from "../../actions/AccountApiActions";
import {
  requestVoidCharge
} from "../../actions/SalesApiActions";
import "./OrderDetails.css";

class OrderDetails extends Component {

  componentDidMount() {
    if (this.props.orderId && !this.unsubscribe) {
      this.subscribe(this.props.orderId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.orderId && (prevProps.orderId !== this.props.orderId)) {
      this.subscribe(this.props.orderId);
    }
  }

  subscribe(orderId) {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.unsubscribe = this.props.subscribeToUpdates(this.props, {});
  }


  render() {
    let {loading, error} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />        
    const order = fromJS(this.props.data.salesOrder);

    let canRetryPayment = order.get("billingStatus") !== "paid";
    let canVoidCharge = order.get("billingStatus") !== "paid";

    return (
      <div className="OrderDetails SalesOrderDetails">
        <WarningBanner show={order.get("billingStatus") === "voided" && order.get("status") === "voided"} message={`This order has been cancelled and billing voided. (${order.get("reason")})`} />
        <WarningBanner show={order.get("gift") === true} error={false} message="This order was marked as a gift by the account holder" />
        <div className="addresses section">
          <h4>Ship to</h4>
          <Address label="Ship To" address={order.getIn(["shipping", 0, "deliveryAddress"], Map())} />
        </div>
        <div className="products section">
          <h4>Order Information</h4>
          <ProductTable
            products={order.get("products")}
            subscriptionName={order.get("subscriptionName")}
            subscriptionFrequencyWeeks={order.get("subscriptionFrequencyWeeks")}
            showSubtotal={false}
            />
        </div>
        {this.renderTrackingList(order.get("shipping"))}
        <div className="charge section">
          <h4>Payments</h4>
          <ChargeView
            salesOrderId={order.get("orderId")}
            />
          <div className="buttons">
            <Button label="Record Payment" onClick={this.handleRecordPayment.bind(this, order.get("accountId"), order.get("orderId"))} />            
            <Button label="Check for Payment" onClick={this.handleCheckForPayment.bind(this, order.get("orderId"))} primary={false} />
            <Button label="Retry Payment" onClick={this.handleRetryPayment.bind(this, order.get("orderId"))} primary={false} active={canRetryPayment} />
            <Button label="Void Charge" onClick={this.handleVoidCharge.bind(this, order.get("orderId"))} primary={false} active={canVoidCharge} />
            <Button label="Download Invoice" onClick={this.handleDownloadInvoice.bind(this, order.get("invoiceNr"))} primary={false} active={order.get("invoiceAvailable")} />
            <Button label="View Payments" onClick={this.handleViewPayments.bind(this, order.get("accountId"), order.get("orderId"))} link={true} />
          </div>            
        </div>        
      </div>
    )
  }

  renderTrackingList(order) {
    if (!List(["dispatch", "in_transit", "delivered", "partially_delivered", "voided", "failed"]).includes(order.get("fulfillmentStatus"))) {
      return null;
    }

    return (
      <div className="tracking section">
        <h4>Package Tracking</h4>
        <TrackingList
          courierId={order.get("courierId")}
          orderId={order.get("orderId")}
          />
      </div>
    )
  }

  handleRecordPayment(accountId, orderId) {
    this.props.requestRecordPayment(accountId, orderId);
  }

  handleCheckForPayment(orderId) {
    this.props.requestCheckPaymentStatus(orderId);
  }

  handleRetryPayment(orderId) {
    this.props.requestRetryPayment(orderId);
  }

  handleDownloadInvoice(invoiceNr) {
    let downloadUrl = InvoiceStorage.getUrl(invoiceNr);
    InvoiceStorage.download(downloadUrl);    
  }

  handleViewPayments(accountId, orderId) {
    this.props.requestViewChargePayments(accountId, orderId);
  }

  handleVoidCharge(orderId) {
    this.props.requestVoidCharge(orderId);
  }
}

const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_ORDER_UPDATED,
      variables: {
        orderId: props.orderId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})


const withSubscription = connect(null, mapDispatchToProps);
const withQuery = graphql(GET_ORDER_WITH_PRODUCTS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      orderId: props.orderId
    }
  })
})


export default connect(null, {
  requestRecordPayment, 
  requestCheckPaymentStatus,
  requestRetryPayment,
  requestViewChargePayments,
  requestVoidCharge
})(withQuery(withSubscription(OrderDetails)));